import { AdminOptionableFilter } from "../AdministrateEnumFilter";

export const LabOptionsFilter = ({ queryParams, pageSize = 100, ...rest }) => {
  return (
    <AdminOptionableFilter
      resource="labs"
      queryParams={{ lab: { order: "lab_name", direction: "asc", per_page: pageSize }, ...queryParams }}
      searchParam="lab_name"
      kept
      {...rest}
    />
  );
};
